export default __webpack_public_path__ + "static/media/UpskillCircle.b93937ec.png";